import React from "react";
import { connect } from "react-redux";
import { sha256 } from "js-sha256";
import { Switch, withRouter, Redirect } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";
import dashboardRoutes from "../../routes/dashboard.jsx";
import PrivateRoute from "../../routes/privateRoute.jsx";
import { logoutUser } from "../../redux/actions/authActions";
import NetworkDetector from "../../components/Notifications/NetworkDetector";
import MainHeader from "../../views/MainDashboard/MainHeader";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";

class Content extends React.PureComponent {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.state = {
      backgroundColor: "white",
      activeColor: "info",
      navStatus: false,
    };

    [
      "_onActive",
      "_onIdle",
      "handleActiveClick",
      "handleBgClick",
      "handlepath",
    ].forEach((v) => (this[v] = this[v].bind(this)));
  }
  componentDidMount() {
    if (this.props.login.isAvailable) {
      if (this.props.service === "account") {
        this.props.history.push({
          // pathname: "/index/my-accounts",
          pathname: "/index/account-management",
        });
      } else if (this.props.service === "wallet") {
        this.props.history.push({
          pathname: "/index/fraud&risk-management",
        });
      } else if (this.props.service === "voucher") {
        this.props.history.push({
          pathname: "/index/voucher-management",
        });
      } else if (this.props.service === "marketplace") {
        this.props.history.push({
          pathname: "/index/currency-management",
        });
      } else if (this.props.service === "prepaidcard") {
        this.props.history.push({
          pathname: "/index/wallet-management",
        });
      } else if (this.props.service === "limitmanagement") {
        this.props.history.push({
          pathname: "/index/limit-management",
        });
      } else if (this.props.service === "kycmanagement") {
        this.props.history.push({
          pathname: "/index/kyc-management",
        });
      } else if (this.props.service === "feeManagement") {
        this.props.history.push({
          pathname: "/index/fee-management",
        });
      } else if (this.props.service === "invoiceManagement") {
        this.props.history.push({
          pathname: "/index/invoice-management",
        });
      } else if (this.props.service === "gatewayManagement") {
        this.props.history.push({
          // pathname: "/index/gateway-management",
          pathname: "/index/transaction-management",
        });
      } else if (this.props.service === "walletOwnerManagement") {
        this.props.history.push({
          pathname: "/index/walletOwnerManagement",
        });
      } else if (this.props.service === "GatewayManagement") {
        this.props.history.push({
          pathname: "/index/Gateway-Management",
        });
      } else if (this.props.service === "userManagement") {
        this.props.history.push({
          pathname: "/index/user-Management",
        });
      } else if (this.props.service === "cashLifting") {
        this.props.history.push({
          pathname: "/index/cash-Lifting",
        });
      } else if (this.props.service === "withdrawEMoney") {
        this.props.history.push({
          pathname: "/index/withdraw-money",
        });
      } else if (this.props.service === "agentDealerMapping") {
        this.props.history.push({
          pathname: "/index/agent-Dealer-Map",
        });
      } else if (this.props.service === "settlementmanagement") {
        this.props.history.push({
          pathname: "/index/settlement-management",
        });
      } else if (this.props.service === "adminFraudRiskManagement") {
        this.props.history.push({
          pathname: "/index/AdminFraudRisk-Management",
        });
      } else if (this.props.service === "adminCurrencyManagement") {
        this.props.history.push({
          pathname: "/index/AdminCurrency-Management",
        });
      } else if (this.props.service === "adminWalletManagement") {
        this.props.history.push({
          pathname: "/index/AdminWallet-Management",
        });
      } else if (this.props.service === "adminTransactionManagement") {
        this.props.history.push({
          pathname: "/index/AdminTransaction-Management",
        });
      } else if (this.props.service === "AdminGatewayManagement") {
        this.props.history.push({
          pathname: "/index/AdminGateway-Managements",
        });
      } else if (this.props.service === "adminKycManagement") {
        this.props.history.push({
          pathname: "/index/AdminKyc-Management",
        });
      } else if (this.props.service === "adminFeeMaster") {
        this.props.history.push({
          pathname: "/index/AdminFee-Master",
        });
      } else if (this.props.service === "adminSetting") {
        this.props.history.push({
          pathname: "/index/AdminSetting",
        });
      } else if (this.props.service === "settings") {
        this.props.history.push({
          pathname: "/index/settings",
        });
      } else if (this.props.service === "dealerProfile") {
        this.props.history.push({
          pathname: "/index/dealerProfile",
        });
      } else if (this.props.service === "dealerDSRManagement") {
        this.props.history.push({
          pathname: "/index/dealerDSRManagement",
        });
      } else if (this.props.service === "dealerCashLifting") {
        this.props.history.push({
          pathname: "/index/dealerCashLifting",
        });
      } else if (this.props.service === "dealerWithdrawEMoney") {
        this.props.history.push({
          pathname: "/index/dealerWithdrawEMoney",
        });
      } else if (this.props.service === "dealerPendingRequest") {
        this.props.history.push({
          pathname: "/index/dealerPendingRequest",
        });
      } else if (this.props.service === "dealerWalletManagement") {
        this.props.history.push({
          pathname: "/index/dealerWalletManagement",
        })
      } else if (this.props.service === "dealerUserManagement") {
        this.props.history.push({
          pathname: "/index/dealerUserManagement",
        });
      } else if (this.props.service === "dealerAgentMaster") {
        this.props.history.push({
          pathname: "/index/dealerAgentMaster",
        });
      } else if (this.props.service === "bankModulebankmaster") {
        this.props.history.push({
          pathname: "/index/bankmaster-dashboard",
        });
      } else if (this.props.service === "bankModulecashLifting") {
        this.props.history.push({
          pathname: "/index/cashlifting-dashboard",
        });
      } else if (this.props.service === "bankWithdrawEMoney") {
        this.props.history.push({
          pathname: "/index/withdray-emoney-dashboard",
        });
      } else if (this.props.service === "bankUserManagement") {
        this.props.history.push({
          pathname: "/index/user-management-dashboard",
        });
      } else if (this.props.service === "userManagementAdmin") {
        this.props.history.push({
          pathname: "/index/user-ManagementAdmin",
        });
      }else if (this.props.service === "adminUserManagementData") {
        this.props.history.push({
          pathname: "/index/AdminUser-Management",
        });
      } 
    }
  }

  handleCallback = (navStatus) => {
    this.setState({ navStatus: navStatus });
    // console.log(this.state.navStatus, "/////////////////");
  };

  handleActiveClick(color) {
    this.setState({ activeColor: color });
  }

  handleBgClick(color) {
    this.setState({ backgroundColor: color });
  }

  _onActive() {
    return null;
  }

  _onIdle() {
    var authToken = this.props.login.data.AuthToken || localStorage.getItem("authToken");
    const req = {
      // customerId: this.props.login.data.customerId,
      // verificationHash: sha256(
      //   this.props.login.data.secKey + this.props.login.data.customerId + "3"
      // ),
      // platformId: "3",
      // cust_device_id: "",
      authToken: authToken,
      authentication: {
        partnerId: "1",
      },
    };
    this.props.logoutUser(req);
  }

  // _onIdle() {
  // 	const req = {
  // 		customerId: this.props.login.data.customerId,
  // 		verificationHash: sha256(
  // 			this.props.login.data.secKey + this.props.login.data.customerId + "3"
  // 		),
  // 		platformId: "3",
  // 		cust_device_id: ""
  // 	};
  // 	this.props.logoutUser(req);
  // }

  handlepath(path) {
    this.setState({ componentPath: path });
  }

  render() {
    const { login } = this.props;
    // return (
    //   <div className="wrappe">
    //     <IdleTimer
    //       ref={(ref) => {
    //         this.idleTimer = ref;
    //       }}
    //       element={document}
    //       onActive={this._onActive}
    //       onIdle={this._onIdle}
    //       onAction={this._onAction}
    //       debounce={250}
    //       timeout={20 * 60000}

    //     />

    return (
      <div className="wrappe">
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this._onActive}
          onIdle={this._onIdle}
          onAction={this._onAction}
          debounce={250}
          timeout={20 * 60000}
        />

        {/* {login.isAvailable ? (
          <MainDashboard />
        ) : (
          <Redirect
            to={{
              pathname: "/index/login",
              search: "?walletOwnerId=1",
            }}
          />
        )} */}
        <Sidebar
          parentCallback={this.handleCallback}
          {...this.props}
          routes={dashboardRoutes}
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
          handlepath={this.handlepath}
        />
        <div
          className="main-panel"
          ref="mainPanel"
          style={{
            width: this.state.navStatus
              ? "calc(100% - 80px)"
              : "calc(100% - 260px)",
          }}
        >
          {login.isAvailable ? (
            <>
              <MainHeader {...this.props} />
              <BreadCrumb
                {...this.props}
                componentPath={this.state.componentPath}
              />
            </>
          ) : (
            <Redirect
              to={{
                pathname: "/index/login",
                search: "?walletOwnerId=1",
              }}
            />
          )}
          <Switch>
            {dashboardRoutes.map((prop, key) => {
              return (
                <PrivateRoute
                  path={prop.path}
                  component={prop.component}
                  key={key}
                  isAvailable={login.isAvailable}
                />
              );
            })}
          </Switch>
          {/* <Footer fluid /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(NetworkDetector(Content))
);
